import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function VerticallyCenteredLayout({ children }) {
    return (_jsxs("div", { className: "VerticallyCenteredLayout", style: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
        }, children: [_jsx("div", { className: "VerticallyCenteredLayout__row", style: { flex: '1 0 48px' }, children: "\u00A0" }), children, _jsx("div", { className: "VerticallyCenteredLayout__row", style: { flex: '1.25 0 120px' }, children: "\u00A0" })] }));
}
